/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreasResponse
 */
export interface BulkUpdateFacilityServiceAreasResponse {
    /**
     * 
     */
    updated: number;
}

/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreasResponse(value: object): value is BulkUpdateFacilityServiceAreasResponse {
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function BulkUpdateFacilityServiceAreasResponseFromJSON(json: any): BulkUpdateFacilityServiceAreasResponse {
    return BulkUpdateFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updated': json['updated'],
    };
}

export function BulkUpdateFacilityServiceAreasResponseToJSON(json: any): BulkUpdateFacilityServiceAreasResponse {
    return BulkUpdateFacilityServiceAreasResponseToJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasResponseToJSONTyped(value?: BulkUpdateFacilityServiceAreasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated': value['updated'],
    };
}

